import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Formik, Form, Field } from 'formik';
import { InputAdornment as Icon } from '@material-ui/core';

import { updateExerciseInfo } from '~/api';

import { Button } from '~/components/_layouts/forms/styles';
import Dialog from '~/components/Dialog';
import {
  SDialogTitle,
  ActionButtonSection,
  defaultFieldProps,
} from '~/components/Dialog/styles';
import Loading from '~/components/Loading';

export default function EditExerciseDialog({
  isOpen,
  setIsOpen,
  exercise,
  refreshBlocks,
  isAdmin,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleEmptyNumbers = (valuesToUpdate) => {
    if (valuesToUpdate.series === '') valuesToUpdate.series = null;
    if (valuesToUpdate.reps === '') valuesToUpdate.reps = null;
    if (valuesToUpdate.weight === '') valuesToUpdate.weight = null;
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      handleEmptyNumbers(values);

      await updateExerciseInfo(exercise.id, values);
      toast.success('Exercício alterado com sucesso !');

      refreshBlocks();
    } catch (error) {
      toast.error('Ops, não foi possivel alterar este exercício!');
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  const getUpdatableFields = () => {
    const { name, series, reps, weight, observations, video } = exercise;
    return { name, series, reps, weight, observations, video };
  };

  return (
    <Dialog open={isOpen}>
      <SDialogTitle>
        {isAdmin ? 'Alterar exercício' : 'Alterar carga'}
      </SDialogTitle>
      <Formik
        enableReinitialize
        initialValues={getUpdatableFields()}
        onSubmit={handleSubmit}
      >
        <Form>
          <div>
            {isAdmin && (
              <>
                <Field
                  name="name"
                  label="Nome do bloco"
                  required
                  {...defaultFieldProps}
                />
                <Field
                  name="series"
                  label="Séries"
                  type="number"
                  {...defaultFieldProps}
                />
                <Field
                  name="reps"
                  label="Repetições"
                  type="number"
                  {...defaultFieldProps}
                />
              </>
            )}

            <Field
              name="weight"
              label="Carga"
              type="number"
              InputProps={{ endAdornment: <Icon position="end">Kg</Icon> }}
              {...defaultFieldProps}
            />

            {isAdmin && (
              <>
                <Field
                  name="observations"
                  label="Observações"
                  {...defaultFieldProps}
                />
                <Field
                  name="video"
                  label="Link do video"
                  {...defaultFieldProps}
                />
              </>
            )}
          </div>

          <ActionButtonSection>
            <Button
              disabled={isLoading}
              type="button"
              cancelButton
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </Button>
            <Button disabled={isLoading} type="submit">
              Alterar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </ActionButtonSection>
        </Form>
      </Formik>
    </Dialog>
  );
}

EditExerciseDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  blockId: PropTypes.number.isRequired,
  exercise: PropTypes.object.isRequired,
  refreshBlocks: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};
